export const eng = {
    firstLogin: {
        tabName: 'Create Account',
        title: 'Create Account',
        subTitle: 'Enter your unique ID',
        createAccountSubTitle: 'Enter username and password',
        idFormPlaceholder: 'Unique ID',
        usernamePlaceholder: 'Username',
        passwordPlaceholder: 'Password',
        buttonNext: 'Next',
        buttonCreate: 'Create Account',
    },
    generalLogin: {
        tabName: 'Log In',
        title: 'Log In',
        subTitle: 'Enter your username and password',
        usernamePlaceholder: 'Username',
        passwordPlaceholder: 'Password',
        button: 'Login',
        forgotPassword: 'forgot password?',
        modalHeader: 'Generate password reset link',
        modalInstructions1: 'Enter your email address to change your password.',
        modalInstructions2:
            "If you don't have an email address associated with your account, please contact your manager.",
        modalButton: 'Send email',
    },
    navBar: {
        home: 'Home',
        learningPlans: 'Learning Plans',
        logOut: 'Log Out',
    },
    userDashboard: {
        pageName: 'Onboarding',
        continueCourses: 'Continue where you left off',
        onboardingCourses: 'Your onboarding plan',
        finishedCourses: 'Finished courses',
        emptyContinueCourses: 'You have no active courses.',
        emptyOnboardingCourses: 'Congratulations! You have finished all courses.',
        emptyFinishedCourses: 'You have not finished any courses yet',
    },
    course: {
        numberOfPages: 'Number of pages: ',
        startCourse: 'Start Course',
        nextPage: 'Next Page',
        previousPage: 'Previous Page',
        goodJob: 'Congratulations!',
        youFinished: 'You have finished the course ',
        startTest: 'Start the course',
        submitQuestion: 'Answer',
        correctAnswer: 'Correct answer',
        finishCourse: 'Finish Course',
    },
    questionnaire: {
        questionnaire: 'Questionnaire ',
        questions: 'questions',
        info1: 'The exam will be automatically graded.',
        info2: 'To pass, you must get a score of at least 7.',
        info3: 'If you fail the exam, you will need to retake the course.',
        info4: '* You can review and modify your answers at any time.',
        info5: ' * Please note that once you have answered a question, you cannot change the answer.',
        startExam: 'start the test',
        previousQuestion: 'Previous question',
        nextQuestion: 'Next question',
        finishExam: 'Finish the test ',
        dialogMessage1: 'Are you sure you want to finish the test?',
        dialogMessage2: 'Attention, you can no longer return to questions!',
        dialogHeader: 'Confirmation',
        anwser: 'Answer',
        correctAnwser: 'Correct answer: ',
        goodJob: 'Congratulations!',
        gradeText: 'You got ',
        youResponded: 'You answered correctly to',
        anwsers: 'Answers',
        yourAnwser: 'You answered',
        backToCourses: 'Back to courses',
    },
    learningPlans: {
        title: 'Learning Plans',
        noPlans: 'There are no learning plans for this position',
        lastUpdate: 'Last update',
        seeCourses: 'See Courses',
        openPlan: 'Open Plan',
        continueCourses: 'Continue where you left off',
        planCourses: 'Plan courses',
        finishedCourses: 'Finished courses',
    },
    resetPassword: {
        header: 'Reset Password',
        subTitle1: 'If you are not',
        subTitle2: 'please igonre this link',
        usernamePlaceholder: 'Username',
        passwordPlaceholder: 'Password',
        button: 'Update password',
        noData1: "Oops! This link doesn't exist.",
        noData2: 'Contact your manager.',
        expired1: 'Oops! This link is expired.',
        expired2: 'Contact your manager.',
    },
};
